// extracted by mini-css-extract-plugin
export var details = "_kw-0";
export var inspectorPopover = "_kw-1";